import React, { Component } from 'react';
import { connect } from 'react-redux';
import Jmoment from 'moment-jalaali';

import ENUMS from '../../enums';
import { enumHelper } from '../../utils';
import { numberWithCommas } from '../../utils/formatter';

class ClientAbsentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
      checkoutList: [],
      headerCheckBox: true,
      checkoutType: '---',
      totalBalance: 0,
      excludeReserveIds: []
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.loaded == false && this.props.checkoutList && this.props.checkoutList.length) {
      const { checkoutList } = this.props;
      checkoutList.forEach(item => {
        const startAt = Jmoment(item.startAt, 'jYYYYjMMjDDHHmm');
        const endAt = Jmoment(item.endAt, 'jYYYYjMMjDDHHmm');

        const diff = endAt.diff(startAt);
        const duration = Jmoment.duration(diff);

        const hours = duration
          .hours()
          .toString()
          .padStart(2, '0');

        const minutes = duration
          .minutes()
          .toString()
          .padStart(2, '0');

        const reserveDuration = `${hours}:${minutes}`;
        item.reserveDuration = reserveDuration;
        item.isChecked = true;
      });
      this.setState({ checkoutList, loaded: true }, () => {
        this.calculateTotalBalance();
      });
    }
  }
  calculateTotalBalance = () => {
    let totalBalance = 0;
    this.state.checkoutList.forEach(item => {
      if (item.isChecked) totalBalance = totalBalance + item.balance;
    });
    this.setState({ totalBalance, checkoutType: this.rowCheckoutTypeCalculation(totalBalance) }, () => {
      this.setExcludedsAndSubmitForm();
    });
  };

  handleRowCheckbox = (event, index) => {
    const { checked } = event.target;
    this.setState(
      state => {
        state.checkoutList[index].isChecked = checked;
        return '';
      },
      () => {
        this.setState({ headerCheckBox: this.state.checkoutList.every(item => item.isChecked) }, () => {
          this.calculateTotalBalance();
        });
      }
    );
  };

  handleHeaderCheckbox = event => {
    const { checked } = event.target;
    this.setState(
      state => {
        state.headerCheckBox = checked;
        state.checkoutList.forEach(item => {
          if (checked) {
            item.isChecked = true;
          } else {
            item.isChecked = false;
          }
        });
        return '';
      },
      () => {
        this.calculateTotalBalance();
      }
    );
  };

  rowCheckoutTypeCalculation = balance => {
    if (balance > 0) {
      return ENUMS.CHECKOUT_TYPES.values.CREDITOR;
    } else if (balance < 0) {
      return ENUMS.CHECKOUT_TYPES.values.DEBTOR;
    } else {
      return ENUMS.CHECKOUT_TYPES.values.NOTHING;
    }
  };

  setExcludedsAndSubmitForm = _ => {
    this.setState(
      state => {
        state.excludeReserveIds = state.checkoutList.filter(item => !item.isChecked).map(item => item.id);
        return '';
      },
      () => {
        this.props.excludeReserveIds(this.state.excludeReserveIds);
      }
    );
  };

  render() {
    const { checkoutList, headerCheckBox, totalBalance, checkoutType } = this.state;

    return (
      <>
        <table className="table table-hover table-striped table-light my-2">
          <thead>
            <tr>
              <th className="text-center">{locales('tables.row')}</th>
              <th className="text-center">
                <input type="checkbox" checked={headerCheckBox} onChange={this.handleHeaderCheckbox} />
              </th>
              <th className="text-center">{locales('tables.date')}</th>
              <th className="text-center">{locales('fields.duration')}</th>
              <th className="text-center">{locales('tables.mealPortions')}</th>
              <th className="text-center">{locales('fields.trackingNumber')}</th>
              <th className="text-center">{locales('tables.peopleCount')}</th>
              <th className="text-center">{locales('tables.prePaid')}</th>
              <th className="text-center">{locales('fields.rsee.amount')}</th>
              <th className="text-center">{locales('tables.totalPrice')}</th>
              <th className="text-center">{locales('tables.status')}</th>
              <th className="text-center">{locales('tables.balance')}</th>
              <th className="text-center">{locales('tables.checkoutType')}</th>
            </tr>
          </thead>
          <tbody>
            {checkoutList.map((item, index) => (
              <tr key={item.id}>
                <td className="text-center">{index + 1}</td>
                <td className="text-center">
                  <input
                    type="checkbox"
                    onChange={event => this.handleRowCheckbox(event, index)}
                    checked={item.isChecked}
                  />
                </td>
                <td className="text-center">{item.date || '---'}</td>
                <td className="text-center">{item.reserveDuration || '---'}</td>
                <td className="text-center">
                  {enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, item.meal)}
                </td>
                <td className="text-center direction-ltr">{item.trackingNumber || '---'}</td>
                <td className="text-center">{item.people || '---'}</td>
                <td className="text-center">{numberWithCommas(item.baseCost) || '---'}</td>
                <td className="text-center">{numberWithCommas(item.rseeContributionAmount) || '---'}</td>
                <td className="text-center">{numberWithCommas(item.totalPrice) || '---'}</td>
                <td className="text-center">
                  {enumHelper.convertEnumValueToTitle(ENUMS.CAFE_RESERVATION.list, item.status)}
                </td>
                <td className="text-center">{numberWithCommas(item.balance) || '---'}</td>
                <td className="text-center">
                  {enumHelper.convertEnumValueToTitle(
                    ENUMS.CHECKOUT_TYPES.list,
                    this.rowCheckoutTypeCalculation(item.balance)
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="col-12 d-flex justify-content-end">
          {locales('titles.totalBalance')} : {totalBalance}
        </div>
        <div className="col-12 d-flex justify-content-end">
          {locales('titles.finalCheckoutType')} :{' '}
          {enumHelper.convertEnumValueToTitle(ENUMS.CHECKOUT_TYPES.list, checkoutType) || '---'}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {};
};
const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientAbsentTable);
